export const getUserNameCognito = (state) => state.auth?.token?.username;
export const getUserType = (state) => state.auth?.token?.type;
export const getToken = (state) => state.auth?.token ?? undefined;
